import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import EntityCommentsChat from "@/common/components/Entity/Chat/View/EntityCommentsChat";
import { ContractDto, EntityType } from "@/core/api/generated/v1";

interface Props {
  contract: ContractDto;
}

export default function CommentsTabContent({ contract }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock spacing={2}>
        <EntityCommentsChat
          entityId={contract.id!}
          entityType={EntityType.Contract}
          entity={contract}
        />
      </ViewContentBlock>
    </PageTabContent>
  );
}
